import React from "react";
import { Modal, ModalBody } from "reactstrap";

import styles from "./SessionExpire.module.scss";

const SessionExpire = ({ isOpen, toggle }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalBody>
        <div className={styles.session_expire}>
          <b>Session Expired</b>
          <span>Please login in again</span>
          <hr></hr>
          <button onClick={() => toggle()}>LOGIN</button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SessionExpire;
